const SceneBase = require("./scene-base.js");

class SceneShadow extends SceneBase {
    static type() {
        return "sceneshadow";
    }
}

module.exports = SceneShadow;